module.exports = __webpack_public_path__ + "img/about-ch3-unhabitat.06e2612c.svg";